import { render, staticRenderFns } from "./FdtPredictionModelSelect.vue?vue&type=template&id=0ddab056&lang=pug&"
import script from "./FdtPredictionModelSelect.vue?vue&type=script&lang=ts&"
export * from "./FdtPredictionModelSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports